import React, { useState } from 'react';
import { useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

import { StoreState } from "../../../store";
import { LANGUAGES } from "../../../Commons/SessionLanguage";
import useSelectLanguage from "../../../Commons/SessionLanguage/useSelectLanguage";


/*
Language selector for the header menu. The language names are shown in their own
language, so no CMS content key is needed here.

Meant to be rendered inside a NavDropdown.Item: expanding the list has to stop
the click from propagating, otherwise the dropdown item closes the whole menu.
*/
const LanguageMenu: React.FC = () => {

    let [expanded, setExpanded] = useState<boolean>(false);

    let selectLanguage = useSelectLanguage();

    let currentCodeLang = useSelector((state: StoreState) => state.i18n.localCode);
    let currentLanguage = LANGUAGES.find(lang => lang.value === currentCodeLang);

    return <>
        <button
            className={'link-button'}
            onClick={(event) => {
                event.stopPropagation();
                setExpanded(!expanded);
            }}
        >
            <FontAwesomeIcon icon={faGlobe} className={'mr-2'} />
            {currentLanguage?.name}
            <FontAwesomeIcon
                icon={expanded ? faChevronUp : faChevronDown}
                className={'ml-2'}
            />
        </button>

        {expanded && <div className={'ml-4 mt-2'}>
            {LANGUAGES.map(lang => (
                <button
                    key={lang.value}
                    className={
                        'd-block link-button py-1' +
                        (lang.value === currentCodeLang ? ' font-weight-bold' : '')
                    }
                    onClick={() => selectLanguage(lang.value)}
                >
                    {lang.name}
                </button>
            ))}
        </div>}
    </>;
};

export default LanguageMenu;
